import { Product } from "@/models";
import { ProductDTO } from "../dtos";

export const mapProductDTOToProduct = (productDTO: ProductDTO): Product => {
  return {
    _id: productDTO._id,
    name: productDTO.name,
    hubspotId: productDTO.hubspotId,
    family: productDTO.family,
    activations: productDTO.activations
      ? {
          nightAgent: productDTO.activations.nightAgent,
          lockNoiseNotifications: productDTO.activations.lockNoiseNotifications,
        }
      : undefined,
  };
};

export const mapProductsDTOToProducts = (productsDTO: ProductDTO[]): Product[] => {
  return productsDTO.map(mapProductDTOToProduct);
};
